/// <reference path="../../../../tools/typings/angularjs/angular.d.ts"/>
/// <reference path="../../components.ts"/>


module DealerwareWebComponents {

    "use strict";

    export class SettingsExpensesDirectiveController {

        public static $inject : string[ ] = [
            '$scope',
            '$stateParams',
            '$q',
            'DealerwareExpensesModel',
            '$mobilityCompanyAuthentication',
            '$dealerwareNotification',
            '$timeout',
            'DataUtils'
        ];

        public expenseSections  : any[]  = [ ];
        public dataUtils        : any;

        constructor(
            public $scope                   : any,
            public $stateParams             : any,
            public $q                       : any,
            public DealerwareExpensesModel  : any,
            public $auth                    : any,
            public $dealerwareNotification  : any,
            public $timeout                 : any,
            public DataUtils                : any
        ) {
            this.dataUtils = DataUtils.getInstance();

            this.getExpenses();
        }

        public setExpenseSection (section : any) : void {

            // Trying to save null when the value is 0.
            //
            section.value = section.chosen || section.hasTaxable ?
                this.dataUtils.unformatDecimalNumber(section.valueDisplay) : 0;
        }

        public saveExpenses () : void {
            this.expenseSections.forEach( ( section: any ) => {
                if (this.isSectionReadyToSave (section)) {
                    this.setExpenseSection (section);
                    this.saveExpense (section);
                }
            });
        }

        public saveExpense (section: any) : ng.IPromise<{}> {

            return this.DealerwareExpensesModel.saveExpenses ({
                params: {
                    location_id     : this.$auth.location.id
                },
                data: {
                    billable_item   : section
                },
                promise: true
            })
            .then( ( response : any ) => {

                this.expenseSections.forEach( ( section : any, index : number ) => {
                    if (response.data.type === section.type) {
                        angular.extend(this.expenseSections[index], response.data);
                        return;
                    }
                });
            })
            .catch( ( response : any ) => {
                this.$dealerwareNotification.apiError(response, '');
            });
        }

        public getExpenses ( ) : void {

            var that = this;

            return this.DealerwareExpensesModel.getExpenses ({
                params: {
                    location_id     : this.$auth.location.id,
                    sort_by         : 'created_at',
                    sort_direction  : 'desc'
                },
                promise: true
            })
            .then( (expenses : any) => {
                that.expenseSections = expenses && expenses.data || [ ];
            })
            .catch( (response : any) => {
                that.$dealerwareNotification.apiError(response, '');
            });
        }

        public isSaveDisabled () : boolean {

            var isSaveDisabled = true;

            this.expenseSections.forEach( ( section: any, i: number ) => {
                if (this.isSectionReadyToSave (section)) {
                    isSaveDisabled = false;
                }
            });

            return isSaveDisabled;
        }

        public isSectionReadyToSave ( section: any ) : boolean {

            // Value field not entered: don't update this item.
            //
            if (this.$scope.expensesForm[section.fieldName].$error.required) {
                return false;
            }

            var normalizedValue         = parseFloat(section.value);
            var normalizedOriginalValue = parseFloat(section.valueOriginal);

            var valueChanged    = normalizedValue !== normalizedOriginalValue;
            var taxableChanged  = ! section.hasTaxable && section.taxable !== section.taxableOriginal;

            // Value field AND taxable field not changed: don't update this item.
            //
            if (! valueChanged && ! taxableChanged) {
                return false;
            }

            // Taxable was changed, but if the value is zero, the change is irrelevant: don't update.
            //
            if (taxableChanged && !valueChanged && normalizedValue === 0) {
                return false;
            }

            return true;
        }
    }


    getDealerwareWebComponentsModule().controller(
        'SettingsExpensesDirectiveController',
        SettingsExpensesDirectiveController
    );

    export class SettingsExpensesDirective implements ng.IDirective {
        public restrict         : string    =   'E';
        public controller       : any       =   'SettingsExpensesDirectiveController';
        public controllerAs     : string    =   'settingsExpensesController';
        public bindToController : boolean   =   true;
        public templateUrl      : string    =   '/components/settings/expenses/expenses-directive.html';
    }

    getDealerwareWebComponentsModule().directive(
        'dealerwareSettingsExpenses',
        ( ) => new SettingsExpensesDirective()
    );

}
